
export default class PublicationList {
    constructor() {
        this.setupSort();
    }

    setupSort() {
        const sortForm = document.querySelector('#list-sort-form');
        const sortSelect = document.querySelector('#list-sort-select');

        if(sortForm) {
            sortSelect.addEventListener('change', e => {
                sortForm.submit();
            })
        }
    }
}
